import { render, staticRenderFns } from "./Producto.vue?vue&type=template&id=8fc0c9bc&"
import script from "./Producto.vue?vue&type=script&lang=js&"
export * from "./Producto.vue?vue&type=script&lang=js&"
import style0 from "./Producto.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Producto.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Producto.vue?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports